$(window).on('load', function () {
	const authorTeaserResult = $('.eichler-author-teaser-result-list');
	if(authorTeaserResult.length){
		const activePagination = authorTeaserResult.find('.pagination').data('activepagination');
		if(activePagination){
			const scrollToPosition = authorTeaserResult.find('.results').position().top;
			const isMobile = window.matchMedia("(max-width: 768px)").matches;
			let mobileJobOfferNav = 0;
			const BookmarkNav = $('.job-offers-marked-items');

			if (isMobile && BookmarkNav.length && BookmarkNav.find('ul.nav').length) {
				mobileJobOfferNav = $('.job-offers-marked-items').find('ul.nav').height()
			}

			$('html, body').animate(
				{scrollTop: scrollToPosition - ($('#navbar').height() + mobileJobOfferNav)}, 500
			);
		}
	}
});
